import React from 'react'
import {
  List,
  Datagrid,
  Filter,
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  TopToolbar,
  ListButton,
  TextField,
  SelectInput,
  SelectField,
  TextInput,
} from 'react-admin'

// TEMP-BANNED: ROLE_PREFERENCE is the banned role for now (see
// api/src/utils/banned.js). When switching to ROLE_BANNED, uncomment its entry
// and drop the "(banned)" suffix from ROLE_PREFERENCE.
const ROLE_CHOICES = [
  // { id: 'ROLE_BANNED', name: 'ROLE_BANNED' },
  { id: 'ROLE_CUSTOMER', name: 'ROLE_CUSTOMER' },
  { id: 'ROLE_PREFERENCE', name: 'ROLE_PREFERENCE (banned)' },
  { id: 'ROLE_ASSISTANT', name: 'ROLE_ASSISTANT' },
  { id: 'ROLE_ASSISTANT_PREFERENCE', name: 'ROLE_ASSISTANT_PREFERENCE' },
  { id: 'ROLE_ADMIN', name: 'ROLE_ADMIN' },
]

const Filters = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <SelectInput source="role" choices={ROLE_CHOICES} />
  </Filter>
)

export const ListView = props => (
  <List
    {...props}
    title="Users"
    filters={<Filters />}
    bulkActionButtons={false}
    exporter={false}
    perPage={25}
  >
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="surname" />
      <TextField source="email" />
      <SelectField source="role" choices={ROLE_CHOICES} />
      <TextField source="lastLicensePlate" />
    </Datagrid>
  </List>
)

const PlaceEditActions = ({basePath}) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
  </TopToolbar>
)

const PlaceEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)

export const EditView = props => (
  <Edit title="Spaces" actions={<PlaceEditActions />} {...props}>
    <SimpleForm toolbar={<PlaceEditToolbar />}>
      <TextField source="name" />
      <TextField source="surname" />
      <TextField source="email" />
      <SelectInput source="role" choices={ROLE_CHOICES} />
      <TextField source="lastLicensePlate" />
    </SimpleForm>
  </Edit>
)

export {default as Icon} from '@material-ui/icons/Person'
